/**
 * @generated SignedSource<<3f26a5760c5f0f13de91acffcd3c1d70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TopicEditFormFetchWebsiteMetadataMutation$variables = {
  url: any;
};
export type TopicEditFormFetchWebsiteMetadataMutation$data = {
  readonly fetchWebsiteMetadata: {
    readonly description: string | null | undefined;
    readonly title: string | null | undefined;
  };
};
export type TopicEditFormFetchWebsiteMetadataMutation = {
  response: TopicEditFormFetchWebsiteMetadataMutation$data;
  variables: TopicEditFormFetchWebsiteMetadataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "concreteType": "WebsiteMetadata",
    "kind": "LinkedField",
    "name": "fetchWebsiteMetadata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicEditFormFetchWebsiteMetadataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopicEditFormFetchWebsiteMetadataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0a9846469d991d94d3a3471701989a3",
    "id": null,
    "metadata": {},
    "name": "TopicEditFormFetchWebsiteMetadataMutation",
    "operationKind": "mutation",
    "text": "mutation TopicEditFormFetchWebsiteMetadataMutation(\n  $url: Url!\n) {\n  fetchWebsiteMetadata(url: $url) {\n    title\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a4fe27e262064c932e2bfd2bdd44293";

export default node;
